import { Component } from '@angular/core';

@Component({
    selector: 'app-lovable-post-composer',
    templateUrl: './lovable-post-composer.component.html',
    styleUrls: ['./lovable-post-composer.component.css'],
})
export class LovablePostComposerComponent {
    text = '';
    readonly avatarUrl = 'https://truthshorts.com/api/content/logo?userID=1';

    toolbarActions = [
        { label: 'Image', icon: 'image' },
        { label: 'Video', icon: 'video' },
        { label: 'Emoji', icon: 'emoji' },
        { label: 'Schedule', icon: 'calendar' },
    ] as const;
}
